import React from 'react';
import { Link } from 'react-router-dom';
import {ImageIllustration} from "../../Image/ImageIllustration";
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faExternalLink, faEye} from "@fortawesome/free-solid-svg-icons";
import ReactTableBase from "../../Table/ReactTableBase";
import RenderCellActif from "../../Table/RenderCellActif";
import {Field, Formik} from "formik";
import {
    ACTIVITES_STATUS, getActivitesStatusIcon,
} from "../../../services/ActivitesService";
import RenderCellSplit from "../../Table/RenderCellSplit";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";

const ActivitesTable = ({ activites, entreprise, contrat, putActifOpenModal = null, handleSubmitContratDetailStatus = null }) => {
    const data = React.useMemo(() => activites, [activites]);

    const renderCellEntreprise = ({ row, value }) => {
        return <Link to={ Routing.generate({
            route: Routing.routes.adminEntreprise,
            params: { entrepriseId: entreprise.id }
        }) }>{entreprise.nom}</Link>;
    }

    const renderCellCreated = ({ value }) => {
        return DateService.formatDate(value);
    }

    const renderCellDate = ({ value }) => {
        return DateService.formatFrenchDateWithoutTime(value);
    }

    const renderCellActions = ({ row, value }) => {
        return (
            <div className={styles.actions}>
                <Link to={Routing.generate({
                    route: Routing.routes.adminActivite,
                    params: { entrepriseId: entreprise.id, contratId: contrat.id, activiteId: row.original.id }
                })}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Détail
                </Link>

                <Link to={Routing.generate({
                    route: Routing.routes.adminActivite,
                    params: { entrepriseId: entreprise.id, contratId: contrat.id, activiteId: row.original.id },
                    queryParams: { mode: 'creation' }
                })}>
                    <FontAwesomeIcon icon={faEdit}/>
                    Modifier
                </Link>

                <Link to={Routing.generate({
                    route: Routing.routes.adminSeances,
                    params: { entrepriseId: entreprise.id, contratId: contrat.id, activiteId: row.original.id },
                })}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Séances
                </Link>
            </div>
        );
    }

    const renderCellCoach = ({ value }) => {
        return <Link to={Routing.generate({
            route: Routing.routes.adminUtilisateur,
            params: { utilisateurId: value.id }
        })}>{value.prenom} {value.nom}</Link>;
    }

    const renderCellType = ({ row, value }) => {
        return <Link to={Routing.generate({
            route: Routing.routes.adminActiviteType,
            params: { activiteTypeId: value.id }
        })}
                     style={{
                         // color: value.clr_font,
                         // backgroundColor: value.clr_bg,
                         padding: "5px 10px",
                     }}>
            {value.label}
        </Link>;
    }

    const renderCellLogo = ({ row, value }) => {
        return <Link to={Routing.generate({
            route: Routing.routes.adminActivite,
            params: { entrepriseId: entreprise.id, contratId: contrat.id, activiteId: row.original.id }
        })}>
            <ImageIllustration src={value.image} openImage={false}/>
        </Link>;
    }

    const renderCellStatus = ({ value, row }) => {
        return (
            <>
                <Formik
                    initialValues={{ status: value ?? "", id: row.original.contratDetailsId }}
                    onSubmit={handleSubmitContratDetailStatus}
                    enableReinitialize
                >
                    {({isSubmitting, setFieldValue, values, submitForm}) => {
                        const handleChange = (e) => {
                            const { name, value } = e.target;
                            setFieldValue(name, value, false);
                            submitForm();
                        };

                        let options = [{"value": "", "label": "-- Sélectionnez un statut --"}];
                        ACTIVITES_STATUS.forEach(status => {
                            options.push(status);
                        });

                        return (
                            <div className={styles.selectContainer}>
                                {getActivitesStatusIcon(value)}
                                <Field as="select" name="status" onChange={handleChange} className={styles.select}>
                                    {options.map(status => (
                                        <option key={status.value} value={status.value.toString()}>
                                            {status.label}
                                        </option>
                                    ))}
                                </Field>
                            </div>
                        );
                    }
                    }
                </Formik>
            </>
        );
    }

    const columns = [
        /*{
            Header: 'Id',
            accessor: 'id',
            Cell: renderCellId,
        },*/
        {
            Header: 'Logo',
            accessor: 'type',
            Cell: renderCellLogo,
        },
        {
            Header: 'Type',
            accessor: 'typeActivite',
            Cell: renderCellType,
        },
        {
            Header: 'Entreprise',
            accessor: 'entreprise',
            Cell: renderCellEntreprise,
        },
        {
            Header: 'Coach',
            accessor: 'coach',
            Cell: renderCellCoach,
        },
        {
            Header: 'Statut',
            accessor: 'contratDetailsStatus',
            Cell: renderCellStatus,
        },
        {
            Header: 'État',
            accessor: 'actif',
            isBoolean: true,
            Cell: RenderCellActif
        },
        {
            Header: 'Début le',
            accessor: 'date_start',
            Cell: renderCellDate,
        },
        {
            Header: 'Fin le',
            accessor: 'date_end',
            Cell: renderCellDate,
        },
        {
            Header: 'Crée le',
            accessor: 'contratDetailsCreated_at',
            Cell: renderCellCreated,
        },
        {
            Header: 'Actions',
            id: 'actions',
            Cell: renderCellActions,
        },
    ];

    return (
        <ReactTableBase dataSource={activites} columnsData={columns} />
    );
};

export default ActivitesTable;
